/* eslint-disable global-require */
module.exports = ['home.privacypolicy.m1', 'component.cookie.overlay.m1', 'component.cookie.overlay.m2', 'component.cookie.overlay.m3', 'component.cookie.overlay.m4', 'component.cookie.overlay.m5'];
